'use client';

import { useRouter } from 'next/navigation';
import React, { Suspense, useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';
import Image from 'next/image';

function DemoMeetingTab() {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));
  const [roomName, setRoomName] = useState('');

  const startMeeting = () => {
    const id = generateRoomId();
    if (e2ee) {
      router.push(`/rooms/${id}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/rooms/${id}`);
    }
  };

  const joinMeeting = () => {
    if (roomName.trim() === '') return;
    if (e2ee) {
      router.push(`/rooms/${roomName}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/rooms/${roomName}`);
    }
  };

  return (
    <div className={styles.tabContent}>
      <p style={{ margin: 0 }}>Join a secure meeting powered by DELQ Solutions.</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', flexWrap: 'wrap' }}>
          <button
            className="lk-button"
            onClick={startMeeting}
            style={{ whiteSpace: 'nowrap', flexGrow: 1, backgroundColor: '#d90a2c' }}
          >
            New Meeting
          </button>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.5rem',
              flexGrow: 1,
              minWidth: '200px',
            }}
          >
            <input
              type="text"
              placeholder="Enter a code or link"
              value={roomName}
              onChange={(ev) => setRoomName(ev.target.value)}
              onKeyDown={(ev) => {
                if (ev.key === 'Enter') {
                  joinMeeting();
                }
              }}
              style={{
                flexGrow: 1,
                padding: '0.5rem',
                borderRadius: '0.25rem',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                backgroundColor: 'transparent',
                color: 'white',
              }}
            />
            <button
              className="lk-button"
              onClick={joinMeeting}
              disabled={roomName.trim() === ''}
              style={{ opacity: roomName.trim() === '' ? 0.5 : 1, backgroundColor: '#d90a2c' }}
            >
              Join
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
            <input
              id="use-e2ee"
              type="checkbox"
              checked={e2ee}
              onChange={(ev) => setE2ee(ev.target.checked)}
            ></input>
            <label htmlFor="use-e2ee">Enable end-to-end encryption</label>
          </div>
          {e2ee && (
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
              <label htmlFor="passphrase">Passphrase</label>
              <input
                id="passphrase"
                type="password"
                value={sharedPassphrase}
                onChange={(ev) => setSharedPassphrase(ev.target.value)}
                style={{
                  flexGrow: 1,
                  padding: '0.5rem',
                  borderRadius: '0.25rem',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  backgroundColor: 'transparent',
                  color: 'white',
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Page() {
  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <Image
            src="https://delqsolutions.com/DELQ-Logo-White-scaled-1.webp"
            alt="DELQ Solutions"
            width="180"
            height="40"
            style={{ marginBottom: '1.5rem' }}
          />
          <h2>
            Secure video conferencing and IT solutions by{' '}
            <a href="https://delqsolutions.com" rel="noopener">
              DELQ Solutions
            </a>
          </h2>
        </div>
        <Suspense fallback="Loading">
          <div className={styles.tabContainer}>
            <DemoMeetingTab />
          </div>
        </Suspense>
      </main>
      <footer data-lk-theme="default">
        Powered by{' '}
        <a href="https://delqsolutions.com" rel="noopener">
          DELQ Solutions
        </a>
        . Professional IT Consulting & Digital Transformation.
      </footer>
    </>
  );
}
